module.exports = __webpack_public_path__ + "static/media/logo146.18ecd661.png";